export const addDays = (date: string, days: string): string => {
  var myDate = new Date(date);
  myDate.setDate(myDate.getDate() + parseInt(days));
  return myDate.toUTCString();
};

export const formateDateToLocaleString = (date: Date) => {
  const month = date.getMonth() + 1; // Month is zero-based
  const day = date.getDate();
  const year = date.getFullYear();

  const formattedDate = `${month.toString().padStart(2, "0")}/${day
    .toString()
    .padStart(2, "0")}/${year}`;

  console.log(formattedDate);
  return formattedDate;
};

export const dateDifferenceInDays = (date1: Date, date2: Date): number => {
  date1.setHours(0, 0, 0, 0);
  date2.setHours(0, 0, 0, 0);
  const diffInTime = date2.getTime() - date1.getTime();  
  const days = diffInTime / 86400000; // it's One day in milliseconds(hours*minutes*seconds*milliseconds)
  return Math.round(days);
};

export const addDaysToDate = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};
